<template>
  <div class="sticky">
    <UserNotification
      :userNotification="lastNotification"
      :showDelete="true"
      @delete="updateUserNotificationDate"
    />
  </div>
</template>

<script>
import UserNotification from "./UserNotification.vue";
export default {
  components: { UserNotification },
  props: { id: null },
  data() {
    return {
      lastId: null,
      notifications: [],
      lastNotification: null,
    };
  },
  watch: {
    id: {
      handler(id) {
        if (id != this.lastId) {
          this.lastId = id;
          this.bind();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async bind() {
      let r = await this.$client.get(
        "/api/userNotification/getLastUserNotification",
        { noProgress: true }
      );
      if (r.data.isSuccess) {
        this.lastNotification = r.data.value.notification;
      }
    },
    async updateUserNotificationDate() {
      let r = await this.$client.post(
        "/api/userNotification/updateUserNotificationDate",
        { noProgress: true }
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("hide-userNotification");
      }
    },
  },
  async created() {
    await bind();
  },
};
</script>

<style scoped>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 998;
}
</style>
